// src/store/employeeSlice.ts
import { createSlice,PayloadAction } from '@reduxjs/toolkit';
import {
  createEmployee,
  createSpouse,
  getEmployees,
  createChild,
  updateChild,
  createEducation,
  updateEducation,
  createParent,
  updateParent,
  createTopSkill,
  updateTopSkill,
  createExperience,
  updateExperience,
  createEmployeeDocument,
  updateEmployeeDocument,
  getEmployeeById,
  updateEmployee,
  updateBankDetails,
  getEmployeeByUserId,
  fetchEmployeeAnalytics,
  getEmployeeBySupervisorId,
  fetchEmployeeOrganizationTree,
  fetchEmployeeTrackingList, 
  fetchEmployeeLocation,
  getEmployeeDetailsByManagerOrHod,
  hierarchyForSupervisorAndHod
} from './employeeAction';
import { EmployeeState,EmployeeTrackingState,Employee,LocationPoint } from './employeeTypes';

const initialState: any = {
  employee: null,
  createdEmployeeId: "",
  employeeFullDetails: null,
  EmployeeAnalytics: null,
  employees: [],
  employeesbyUser: [],
  employeeBySupervisor: [],
  employeeHierarchy: [],
  EmployeeDetailsByManagerOrHod: [],
  Hierarchy: [],
  bank: null,
  // For create employee
  createEmployeeError: null,
  createEmployeeSuccess: false,
  createEmployeeLoading: false,
  // For update bank
  updateBankError: null,
  updateBankSuccess: false,
  updateBankLoading: false,

  // For fetching employees
  getEmployeeError: null,
  getEmployeeSuccess: false,
  getEmployeeLoading: false,

  employeeHierarchyLoading: false,
  employeeHierarchySuccess: false,
  employeeHierarchyError: null,

  // For fetching employee by ID
  getEmployeeByIdError: null,
  getEmployeeByIdSuccess: false,
  getEmployeeByIdLoading: false,

  // For fetching employee by User ID
  getEmployeeByUserIdError: null,
  getEmployeeByUserIdSuccess: false,
  getEmployeeByUserIdLoading: false,

  // For update employee
  updateEmployeeError: null,
  updateEmployeeSuccess: false,
  updateEmployeeLoading: false,

  // For create spouse
  createSpouseError: null,
  createSpouseSuccess: false,
  createSpouseLoading: false,

  // For create child
  createChildError: null,
  createChildSuccess: false,
  createChildLoading: false,

  // For update child
  updateChildError: null,
  updateChildSuccess: false,
  updateChildLoading: false,

  // For create education
  createEducationError: null,
  createEducationSuccess: false,
  createEducationLoading: false,

  // For update education
  updateEducationError: null,
  updateEducationSuccess: false,
  updateEducationLoading: false,

  // For create parent
  createParentError: null,
  createParentSuccess: false,
  createParentLoading: false,

  // For update parent
  updateParentError: null,
  updateParentSuccess: false,
  updateParentLoading: false,

  // For create top skill
  createTopSkillError: null,
  createTopSkillSuccess: false,
  createTopSkillLoading: false,

  // For update top skill
  updateTopSkillError: null,
  updateTopSkillSuccess: false,
  updateTopSkillLoading: false,

  // For create experience
  createExperienceError: null,
  createExperienceSuccess: false,
  createExperienceLoading: false,

  // For update experience
  updateExperienceError: null,
  updateExperienceSuccess: false,
  updateExperienceLoading: false,

  // For create document
  createEmployeeDocumentError: null,
  createEmployeeDocumentSuccess: false,
  createEmployeeDocumentLoading: false,

  // For update document
  updateEmployeeDocumentError: null,
  updateEmployeeDocumentSuccess: false,
  updateEmployeeDocumentLoading: false,
  // For update document
  EmployeeAnalyticError: null,
  EmployeeAnalyticSuccess: false,
  EmployeeAnalyticLoading: false,
  // For update document
  EmployeeBySuperviosrError: null,
  EmployeeBySuperviosrSuccess: false,
  EmployeeBySuperviosrLoading: false,
//for location
   list: [],
  locations: {},
  loading: false,
  success: false,
  error: null,
};

const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    setCreatedEmployeeId: (state, action: PayloadAction<number | null>) => {
      state.createdEmployeeId = action.payload;
    },
    resetCreatedEmployeeId: (state) => {
      state.createdEmployeeId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle create employee
      .addCase(createEmployee.pending, (state) => {
        state.createEmployeeLoading = true;
        state.createEmployeeError = null;
        state.createEmployeeSuccess = false;
      })
      .addCase(createEmployee.fulfilled, (state, action) => {
        state.createEmployeeLoading = false;
        state.employee = action.payload.data;
        state.createdEmployeeId = action.payload.data?.EmployeeId ?? null;
        state.createEmployeeError = null;
        state.createEmployeeSuccess = true;
      })
      .addCase(createEmployee.rejected, (state, action) => {
        state.createEmployeeLoading = false;
        state.createEmployeeSuccess = false;
        state.createEmployeeError = action.payload as string;
      })

      // Handle update bank
      .addCase(updateBankDetails.pending, (state) => {
        state.updateBankLoading = true;
        state.updateBankError = null;
        state.updateBankSuccess = false;
      })
      .addCase(updateBankDetails.fulfilled, (state, action) => {
        state.updateBankLoading = false;
        state.bank = action.payload.data;
        state.updateBankError = null;
        state.updateBankSuccess = true;
      })
      .addCase(updateBankDetails.rejected, (state, action) => {
        state.updateBankLoading = false;
        state.updateBankError = false;
        state.updateBankSuccess = action.payload as string;
      })

      // Handle fetch employee organization tree
      .addCase(fetchEmployeeOrganizationTree.pending, (state) => {
        state.employeeHierarchyLoading = true;
        state.employeeHierarchyError = null;
        state.employeeHierarchySuccess = false;
      })
      .addCase(fetchEmployeeOrganizationTree.fulfilled, (state, action) => {
        state.employeeHierarchyLoading = false;
        state.employeeHierarchySuccess = true;
        state.employeeHierarchy = action.payload.data || []; // Assuming API response has `data`
      })
      .addCase(fetchEmployeeOrganizationTree.rejected, (state, action) => {
        state.employeeHierarchyLoading = false;
        state.employeeHierarchySuccess = false;
        state.employeeHierarchyError = action.payload as string;
      })


      .addCase(updateEmployee.pending, (state) => {
        state.updateEmployeeLoading = true;
        state.updateEmployeeError = null;
        state.updateEmployeeSuccess = false;
      })
      .addCase(updateEmployee.fulfilled, (state, action) => {
        state.updateEmployeeLoading = false;
        state.employee = action.payload.data; // Assuming response contains updated employee data
        state.updateEmployeeError = null;
        state.updateEmployeeSuccess = true;
      })
      .addCase(updateEmployee.rejected, (state, action) => {
        state.updateEmployeeLoading = false;
        state.updateEmployeeSuccess = false;
        state.updateEmployeeError = action.payload as string;
      })


      // Handle create spouse
      .addCase(createSpouse.pending, (state) => {
        state.createSpouseLoading = true;
        state.createSpouseError = null;
        state.createSpouseSuccess = false;
      })
      .addCase(createSpouse.fulfilled, (state, action) => {
        state.createSpouseLoading = false;
        state.createSpouseError = null;
        state.createSpouseSuccess = true;
      })
      .addCase(createSpouse.rejected, (state, action) => {
        state.createSpouseLoading = false;
        state.createSpouseSuccess = false;
        state.createSpouseError = action.payload as string;
      })

      // Handle fetch employees
      .addCase(getEmployees.pending, (state) => {
        state.getEmployeeLoading = true;
        state.getEmployeeError = null;
        state.getEmployeeSuccess = false;
      })
      .addCase(getEmployees.fulfilled, (state, action) => {
        state.getEmployeeLoading = false;
        state.employees = action.payload.data;
        state.getEmployeeError = null;
        state.getEmployeeSuccess = true;
      })
      .addCase(getEmployees.rejected, (state, action) => {
        state.getEmployeeLoading = false;
        state.getEmployeeSuccess = false;
        state.getEmployeeError = action.payload as string;
      })
      // Handle get employee by ID
      .addCase(getEmployeeById.pending, (state) => {
        state.getEmployeeByIdLoading = true;
        state.getEmployeeByIdError = null;
        state.getEmployeeByIdSuccess = false;
      })
      .addCase(getEmployeeById.fulfilled, (state, action) => {
        state.getEmployeeByIdLoading = false;
        state.employeeFullDetails = action.payload.data;
        state.getEmployeeByIdError = null;
        state.getEmployeeByIdSuccess = true;
      })
      .addCase(getEmployeeById.rejected, (state, action) => {
        state.getEmployeeByIdLoading = false;
        state.getEmployeeByIdSuccess = false;
        state.getEmployeeByIdError = action.payload as string;
      })
      // Handle get employee by supervisor id
      .addCase(getEmployeeBySupervisorId.pending, (state) => {
        state.EmployeeBySuperviosrLoading = true;
        state.EmployeeBySuperviosrError = null;
        state.EmployeeBySuperviosrSuccess = false;
      })
      .addCase(getEmployeeBySupervisorId.fulfilled, (state, action) => {
        state.EmployeeBySuperviosrLoading = false;
        state.employeeBySupervisor = action.payload.data;
        state.EmployeeBySuperviosrError = null;
        state.EmployeeBySuperviosrSuccess = true;
      })
      .addCase(getEmployeeBySupervisorId.rejected, (state, action) => {
        state.EmployeeBySuperviosrLoading = false;
        state.EmployeeBySuperviosrSuccess = false;
        state.EmployeeBySuperviosrError = action.payload as string;
      })
      // Handle get employee by userID
      .addCase(getEmployeeByUserId.pending, (state) => {
        state.getEmployeeByUserIdLoading = true;
        state.getEmployeeByUserIdError = null;
        state.getEmployeeByUserIdSuccess = false;
      })
      .addCase(getEmployeeByUserId.fulfilled, (state, action) => {
        state.getEmployeeByUserIdLoading = false;
        state.employeesbyUser = action.payload.data;
        state.getEmployeeByUserIdError = null;
        state.getEmployeeByUserIdSuccess = true;
      })
      .addCase(getEmployeeByUserId.rejected, (state, action) => {
        state.getEmployeeByUserIdLoading = false;
        state.getEmployeeByUserIdSuccess = false;
        state.getEmployeeByUserIdError = action.payload as string;
      })
      // Handle create child
      .addCase(createChild.pending, (state) => {
        state.createChildLoading = true;
        state.createChildError = null;
        state.createChildSuccess = false;
      })
      .addCase(createChild.fulfilled, (state, action) => {
        state.createChildLoading = false;
        state.createChildError = null;
        state.createChildSuccess = true;
      })
      .addCase(createChild.rejected, (state, action) => {
        state.createChildLoading = false;
        state.createChildSuccess = false;
        state.createChildError = action.payload as string;
      })

      // Handle update child
      .addCase(updateChild.pending, (state) => {
        state.updateChildLoading = true;
        state.updateChildError = null;
        state.updateChildSuccess = false;
      })
      .addCase(updateChild.fulfilled, (state, action) => {
        state.updateChildLoading = false;
        state.updateChildError = null;
        state.updateChildSuccess = true;
      })
      .addCase(updateChild.rejected, (state, action) => {
        state.updateChildLoading = false;
        state.updateChildSuccess = false;
        state.updateChildError = action.payload as string;
      })

      // Handle create education
      .addCase(createEducation.pending, (state) => {
        state.createEducationLoading = true;
        state.createEducationError = null;
        state.createEducationSuccess = false;
      })
      .addCase(createEducation.fulfilled, (state, action) => {
        state.createEducationLoading = false;
        state.createEducationError = null;
        state.createEducationSuccess = true;
      })
      .addCase(createEducation.rejected, (state, action) => {
        state.createEducationLoading = false;
        state.createEducationSuccess = false;
        state.createEducationError = action.payload as string;
      })

      // Handle update education
      .addCase(updateEducation.pending, (state) => {
        state.updateEducationLoading = true;
        state.updateEducationError = null;
        state.updateEducationSuccess = false;
      })
      .addCase(updateEducation.fulfilled, (state, action) => {
        state.updateEducationLoading = false;
        state.updateEducationError = null;
        state.updateEducationSuccess = true;
      })
      .addCase(updateEducation.rejected, (state, action) => {
        state.updateEducationLoading = false;
        state.updateEducationSuccess = false;
        state.updateEducationError = action.payload as string;
      })
      // Handle create parent
      .addCase(createParent.pending, (state) => {
        state.createParentLoading = true;
        state.createParentError = null;
        state.createParentSuccess = false;
      })
      .addCase(createParent.fulfilled, (state, action) => {
        state.createParentLoading = false;
        state.createParentError = null;
        state.createParentSuccess = true;
      })
      .addCase(createParent.rejected, (state, action) => {
        state.createParentLoading = false;
        state.createParentSuccess = false;
        state.createParentError = action.payload as string;
      })

      // Handle update parent
      .addCase(updateParent.pending, (state) => {
        state.updateParentLoading = true;
        state.updateParentError = null;
        state.updateParentSuccess = false;
      })
      .addCase(updateParent.fulfilled, (state, action) => {
        state.updateParentLoading = false;
        state.updateParentError = null;
        state.updateParentSuccess = true;
      })
      .addCase(updateParent.rejected, (state, action) => {
        state.updateParentLoading = false;
        state.updateParentSuccess = false;
        state.updateParentError = action.payload as string;
      })

      // Handle create top skill
      .addCase(createTopSkill.pending, (state) => {
        state.createTopSkillLoading = true;
        state.createTopSkillError = null;
        state.createTopSkillSuccess = false;
      })
      .addCase(createTopSkill.fulfilled, (state, action) => {
        state.createTopSkillLoading = false;
        state.createTopSkillError = null;
        state.createTopSkillSuccess = true;
      })
      .addCase(createTopSkill.rejected, (state, action) => {
        state.createTopSkillLoading = false;
        state.createTopSkillSuccess = false;
        state.createTopSkillError = action.payload as string;
      })

      // Handle update top skill
      .addCase(updateTopSkill.pending, (state) => {
        state.updateTopSkillLoading = true;
        state.updateTopSkillError = null;
        state.updateTopSkillSuccess = false;
      })
      .addCase(updateTopSkill.fulfilled, (state, action) => {
        state.updateTopSkillLoading = false;
        state.updateTopSkillError = null;
        state.updateTopSkillSuccess = true;
      })
      .addCase(updateTopSkill.rejected, (state, action) => {
        state.updateTopSkillLoading = false;
        state.updateTopSkillSuccess = false;
        state.updateTopSkillError = action.payload as string;
      })

      // Handle create experience
      .addCase(createExperience.pending, (state) => {
        state.createExperienceLoading = true;
        state.createExperienceError = null;
        state.createExperienceSuccess = false;
      })
      .addCase(createExperience.fulfilled, (state, action) => {
        state.createExperienceLoading = false;
        state.createExperienceError = null;
        state.createExperienceSuccess = true;
      })
      .addCase(createExperience.rejected, (state, action) => {
        state.createExperienceLoading = false;
        state.createExperienceSuccess = false;
        state.createExperienceError = action.payload as string;
      })

      // Handle update experience
      .addCase(updateExperience.pending, (state) => {
        state.updateExperienceLoading = true;
        state.updateExperienceError = null;
        state.updateExperienceSuccess = false;
      })
      .addCase(updateExperience.fulfilled, (state, action) => {
        state.updateExperienceLoading = false;
        state.updateExperienceError = null;
        state.updateExperienceSuccess = true;
      })
      .addCase(updateExperience.rejected, (state, action) => {
        state.updateExperienceLoading = false;
        state.updateExperienceSuccess = false;
        state.updateExperienceError = action.payload as string;
      })

      // Handle create employee document
      .addCase(createEmployeeDocument.pending, (state) => {
        state.createEmployeeDocumentLoading = true;
        state.createEmployeeDocumentError = null;
        state.createEmployeeDocumentSuccess = false;
      })
      .addCase(createEmployeeDocument.fulfilled, (state, action) => {
        state.createEmployeeDocumentLoading = false;
        state.createEmployeeDocumentError = null;
        state.createEmployeeDocumentSuccess = true;
      })
      .addCase(createEmployeeDocument.rejected, (state, action) => {
        state.createEmployeeDocumentLoading = false;
        state.createEmployeeDocumentSuccess = false;
        state.createEmployeeDocumentError = action.payload as string;
      })

      // Handle update employee document
      .addCase(updateEmployeeDocument.pending, (state) => {
        state.updateEmployeeDocumentLoading = true;
        state.updateEmployeeDocumentError = null;
        state.updateEmployeeDocumentSuccess = false;
      })
      .addCase(updateEmployeeDocument.fulfilled, (state, action) => {
        state.updateEmployeeDocumentLoading = false;
        state.updateEmployeeDocumentError = null;
        state.updateEmployeeDocumentSuccess = true;
      })
      .addCase(updateEmployeeDocument.rejected, (state, action) => {
        state.updateEmployeeDocumentLoading = false;
        state.updateEmployeeDocumentSuccess = false;
        state.updateEmployeeDocumentError = action.payload as string;
      })
      // Handle fetch employees
      .addCase(fetchEmployeeAnalytics.pending, (state) => {
        state.EmployeeAnalyticLoading = true;
        state.EmployeeAnalyticError = null;
        state.EmployeeAnalyticSuccess = false;
      })
      .addCase(fetchEmployeeAnalytics.fulfilled, (state, action) => {
        state.EmployeeAnalyticLoading = false;
        state.EmployeeAnalytics = action.payload.data;
        state.EmployeeAnalyticError = null;
        state.EmployeeAnalyticSuccess = true;
      })
      .addCase(fetchEmployeeAnalytics.rejected, (state, action) => {
        state.EmployeeAnalyticLoading = false;
        state.EmployeeAnalyticSuccess = false;
        state.EmployeeAnalyticError = action.payload as string;
      })
      .addCase(fetchEmployeeTrackingList.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fetchEmployeeTrackingList.fulfilled, (state, action: PayloadAction<Employee[]>) => {
        state.loading = false;
        state.success = true;
        state.list = action.payload;
        state.error = null;
      })
      .addCase(fetchEmployeeTrackingList.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      })
    // Employee location
    .addCase(fetchEmployeeLocation.pending, (state) => {
        state.locationLoading = true;
        state.locationSuccess = false;
        state.locationError = null;
      })
      .addCase(fetchEmployeeLocation.fulfilled, (state, action) => {
      const { employeeId, locations } = action.payload;
      state.locationLoading = false;
      state.locationSuccess = true;
      state.locations[employeeId] = locations; 
      state.locationError = null;
    })
      .addCase(fetchEmployeeLocation.rejected, (state, action) => {
        state.locationLoading = false;
        state.locationSuccess = false;
        state.locationError = action.payload as string;
      })

      //getEmployeeDetailsbyHOD and Supervisor
      .addCase(getEmployeeDetailsByManagerOrHod.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getEmployeeDetailsByManagerOrHod.fulfilled, (state, action: PayloadAction<Employee[]>) => {
        state.loading = false;
        state.success = true;
        state.EmployeeDetailsByManagerOrHod = action.payload;
        state.error = null;
      })
      .addCase(getEmployeeDetailsByManagerOrHod.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      })

      //get hierarchy for supervisor and Hods
      .addCase(hierarchyForSupervisorAndHod.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(hierarchyForSupervisorAndHod.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.Hierarchy = action.payload;
        state.error = null;
      })
      .addCase(hierarchyForSupervisorAndHod.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      })
  },
});

export const { setCreatedEmployeeId, resetCreatedEmployeeId } = employeeSlice.actions;
export default employeeSlice.reducer;
